import * as z from "zod";
import { gql } from "graphql-request";
import { Image, ImageFragment } from "../image";
import { Sys, SysFragment } from "../sys";
import { UnifiedButton, UnifiedButtonFragment } from "../unifiedButton";

export const LocalizedHero = z.object({
  __typename: z.literal("LocalizedHero"),
  sys: Sys,
  image: Image.nullable(),
  imageEn: Image.nullable(),
  buttonsCollection: z
    .object({
      items: z.array(UnifiedButton).nullish(),
    })
    .nullish(),
});

export type LocalizedHero = z.infer<typeof LocalizedHero>;

export const LocalizedHeroFragment = gql`
  fragment LocalizedHeroFragment on LocalizedHero {
    __typename
    sys {
      ...SysFragment
    }
    image {
      ...ImageFragment
    }
    imageEn: image(locale: "en") {
      ...ImageFragment
    }
    buttonsCollection {
      items {
        __typename
        ... on UnifiedButton {
          ...UnifiedButtonFragment
        }
      }
    }
  }
  ${SysFragment}
  ${ImageFragment}
  ${UnifiedButtonFragment}
`;
